// ============================================================================
// SupportChannelBadge.tsx — канал-источник обращения (иконка + подпись):
// ЕДИНАЯ точка отображения канала в карточке очереди и в карточке обращения.
// Подписи — SSoT lib/supportInbox (коды сервера chat | telegram | max);
// неизвестный канал — подпись как есть, без иконки (никаких выдуманных каналов).
// ============================================================================

import { supportChannelIcon, supportChannelLabel } from '@/lib/supportInbox';

interface Props {
  /** Код канала сервера ('' = внутренний чат). */
  channel: string;
  /** «Канал: …» — подпись строки в деталях обращения. */
  withPrefix?: boolean;
  className?: string;
}

export function SupportChannelBadge({ channel, withPrefix, className }: Props) {
  const Icon = supportChannelIcon(channel);
  return (
    <span className={`inline-flex items-center gap-1 ${className || ''}`}>
      {withPrefix && <span>Канал:</span>}
      {Icon && <Icon className="h-3 w-3 shrink-0" />}
      <span>{supportChannelLabel(channel)}</span>
    </span>
  );
}
